import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  RESET_SELECTED_FILTERS,
  SET_DATES,
  SET_FILTERS_DIRTY,
  SET_FILTERS_LOADING,
  SET_LOADING,
  SET_UPDATES_LOADING,
  UPDATE_CUSTOM_RANGE,
  UPDATE_DATES,
  UPDATE_FILTER,
  UPDATE_MODULE_VIEW,
  UPDATE_TABLE_VIEW_SELECTED
} from "./discountsSagas";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOption,
  getSelectedRangeOptionWithCustom
} from "../../../../utils/date-range-options";
import { VIEW_OPTIONS } from "../constants";

export const initialState = {
  isLoading: true,
  initialRequest: false,
  updatesLoading: false,
  filtersLoading: false,
  currentUser: {},
  chartsData: { table: {} },
  trendData: { data_table: { rows: [], cols: [] }, options: {} },
  filtersDirty: false,
  rangeOptions: [],
  filters: {
    membershipTypes: [],
    staffs: []
  },
  selectedFilters: {
    moduleView: VIEW_OPTIONS[0],
    membershipTypes: [],
    staffs: [],
    table_view: false
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      filtersLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      rangeOptions:
        state.selectedFilters.moduleView.id === "trend"
          ? getRangeOptionsWithCustom(state.rangeOptions, action)
          : getRangeOptions(state.currentUser.calendarEndDate, state.currentUser.calendarStartDate),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        // getSelectedRangeOption always labels Month To Date — correct for Breakdown, but Trend's
        // default is last 12 months, so it needs a label reflecting the actual computed range.
        rangeOption:
          state.selectedFilters.moduleView.id === "trend"
            ? getSelectedRangeOptionWithCustom(action)
            : getSelectedRangeOption(action.payload.endDate)
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    // Everything starts selected, so the trigger reads "N selected" rather than "Not selected".
    [FETCH_FILTERS_SUCCESS]: (state, { payload }) => {
      const membershipTypes = payload.membership_types || [];
      const staffs = payload.staffs || [];

      return {
        ...state,
        filters: { membershipTypes, staffs },
        selectedFilters: { ...state.selectedFilters, membershipTypes, staffs }
      };
    },
    // One endpoint, one success action — routed to whichever state slice the current view reads.
    [FETCH_DATA_SUCCESS]: (state, action) =>
      state.selectedFilters.moduleView.id === "trend"
        ? { ...state, trendData: action.payload }
        : { ...state, chartsData: action.payload },
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        // Clearing every option reverts to all of them rather than filtering everything out.
        [key]: data.length ? data : state.filters[key]
      }
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedFilters: {
        ...state.selectedFilters,
        ...action.payload,
        rangeOption: getSelectedRangeOptionWithCustom(action)
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        ...getDateRanges(
          state.currentUser.calendarEndDate,
          action.payload,
          state.currentUser.calendarStartDate
        ),
        rangeOption: action.payload
      }
    }),
    [UPDATE_MODULE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        moduleView: action.payload
      }
    }),
    [RESET_SELECTED_FILTERS]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: {
        ...initialState.selectedFilters,
        moduleView: state.selectedFilters.moduleView,
        membershipTypes: state.filters.membershipTypes,
        staffs: state.filters.staffs
      }
    })
  },
  initialState
);
